// extracted by mini-css-extract-plugin
export var cookie = "cookie-consent-module--cookie--b2rPw";
export var container = "cookie-consent-module--container--2bjmp";
export var close = "cookie-consent-module--close--JDa7u";